import { GUI } from "three/examples/jsm/libs/dat.gui.module.js";
// https://github.com/dataarts/dat.gui/blob/master/API.md

const _instance = new GUI()
export default _instance